import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { AccessLevelGuard } from './guards/role.guard';
import { MarkdownModule } from 'ngx-markdown';

const routes: Routes = [
  {
    canActivate: [AutoLoginPartialRoutesGuard],
    loadComponent: () => import('@pages/sales-sidekick/sales-sidekick.component').then((m) => m.SalesSidekickComponent),
    path: '',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard, AccessLevelGuard()],
    loadComponent: () => import('@pages/admin/admin.component').then((m) => m.AdminComponent),
    path: 'admin',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard, AccessLevelGuard()],
    loadComponent: () => import('@pages/add-document/add-document.component').then((m) => m.AddDocumentComponent),
    path: 'admin/add-document',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard, AccessLevelGuard()],
    loadComponent: () => import('@pages/edit-document/edit-document-page.component').then((m) => m.EditDocumentComponent),
    path: 'admin/edit-document',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard, AccessLevelGuard()],
    loadComponent: () => import('@pages/view-documents-page/view-documents-page.component').then((m) => m.ViewDocumentsPageComponent),
    path: 'admin/view-documents',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard, AccessLevelGuard()],
    loadComponent: () => import('@pages/product-questions/product-questions-page.component').then((m) => m.ProductQuestionsComponent),
    path: 'admin/questions',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/',
  },
  {
    loadComponent: () => import('@pages/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
    path: 'unauthorized',
  },
  {
    loadComponent: () => import('@pages/error/error.component').then((m) => m.ErrorComponent),
    path: 'error',
  },
  {
    loadComponent: () => import('@pages/no-access/no-access.component').then((m) => m.NoAccessComponent),
    path: 'no-access',
  },
  {
    loadComponent: () => import('@components/callback/callback.component').then((m) => m.CallbackComponent),
    path: 'callback',
  },
  {
    canActivate: [AutoLoginPartialRoutesGuard],
    loadComponent: () => import('@pages/sales-sidekick/sales-sidekick.component').then((m) => m.SalesSidekickComponent),
    path: ':session-id',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), MarkdownModule.forRoot()],
  exports: [RouterModule],
})
export class AppRoutingModule {}
